const profiles = [
	{
		path: '/ai/profiles/list',
		name: 'ai-profiles-list',
		component: () => import('@/views/ai/profiles/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGAI,profiles',
		},
	},
]

export default profiles
